import { render, staticRenderFns } from "./RUT-input.vue?vue&type=template&id=cdf60476&scoped=true"
import script from "./RUT-input.vue?vue&type=script&lang=js"
export * from "./RUT-input.vue?vue&type=script&lang=js"
import style0 from "./RUT-input.vue?vue&type=style&index=0&id=cdf60476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf60476",
  null
  
)

export default component.exports